import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-surface/10 bg-inverse-deep px-5 py-14" data-id="element-109" data-mp="3geze367ujv27">
      <div className="mx-auto max-w-5xl text-center" data-id="element-110" data-mp="32nulgo2wc31d">
        <p className="font-display text-xl font-black uppercase tracking-tight text-surface" data-id="element-111" data-mp="32p5qer82vgu2">
          <span aria-hidden="true" data-id="element-112" data-mp="36q953aee36tp">♫ </span>Musique Prête™
        </p>
        <p className="mx-auto mt-3 max-w-md text-xs leading-relaxed text-surface/55" data-id="element-113" data-mp="3ueiltxwqx4dz">
          La ressource définitive pour les professeurs de musique qui aiment
          leur métier.
        </p>
        <nav aria-label="Footer" data-id="element-114" data-mp="3levih6kghoia">
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-surface/65" data-id="element-115" data-mp="3ldu52vfywpxe">
            {footerLinks.map(link => <li key={link} data-id="element-116" data-mp="29yxcxcohlklt">
                <a href="#offerta" className="transition-colors duration-150 ease-out-strong hover:text-primary-soft focus:outline-none focus-visible:underline" data-id="element-117" data-mp="29xm0ypkw16jm">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-surface/40" data-id="element-118" data-mp="3gck196cnssoa">
          © 2026 Musique Prête™ — Tous droits réservés.
        </p>
      </div>
    </footer>;
}